<script lang="ts">import transparencySidebarIcon from "../icons/transparency-sidebar.png";
export let size = 20;
export let active = false;
export let hover = false;
export let color = undefined;
</script>

<img
	src={transparencySidebarIcon}
	alt="Transparency"
	width={size}
	height={size}
	style="width: {size}px; height: {size}px; object-fit: contain;"
	class:active
	class:hover
/>

<style>
	img {

    display: block
}

	img.active,
	img.hover {

    opacity: 1
}
</style>
